import React, { useState, useEffect } from 'react';
import TagManager from 'react-gtm-module';
import NumberFormat from 'react-number-format';
import { toaster } from 'evergreen-ui';
import * as Style from './style';
import Card from '../../../components/Card';
import Button from '../../../components/Campanhas/Button';
import FileInput from '../../../components/Briefing/FileInput';
import Thank from '../../../components/Campanhas/SpecialProject/ThankMessage';
import api from '../../../services/api';
import Utils from '../../../services/utils';

const ProjetosEspeciais = () => {
	const [sendedForm, setSendedForm] = useState(false);
	const [value, setValue] = useState('');
	const [filesArray, setFilesArray] = useState([]);
    const [content, setContent] = useState('');
	const [contentError, setContentError] = useState(false);

    useEffect(() => {
        window.scroll(0, 0);
		TagManager.dataLayer({
			dataLayer: {
				event: 'PageView',
				page: 'Projetos especiais',
			},
			dataLayerName: 'Campanhas',
		});
    }, []);

	const sendForm = () => {
        if (content === '') {
            setContentError(true);
            return false;
            }
		const files = [];
		filesArray.map(e => files.push(e.id));
		api.post('/special-projects-reqs', {
			value: Utils.currencyToFloat(value),
			content,
			files,
		})
		.then((response) => {
			if (response.status === 201) {
				setSendedForm(true);
			}
		})
        .catch(() => toaster.danger('Falha ao enviar projeto especial, tente novamente'));
        return true;
    };

	return (
		<Style.SpecialProjectContent>
			<div className="header">
				<h1>Projetos Especiais</h1>
				<h2>
					{
						sendedForm
						? 'Para campanhas exclusivas!'
						: 'Gostaria de uma campanha exclusiva? Siga as instruções abaixo!'
					}
				</h2>
			</div>
			{
				sendedForm
				? Thank()
				: (
					<>
						<Card title="Projetos Especiais" classComponent="card-special-project">
							<p>
								Este espaço é dedicado às campanhas que precisam seguir um {}
								formato diferente das opções padrões listadas no painel inicial. {}
								Conte para gente as suas necessidades no campo {}
								dedicado às informações relevantes logo abaixo. {}
								Analisaremos a viabilidade do seu pedido e retornaremos o quanto antes.
							</p>
							<p>
								*Se você escolheu desenvolver suas próprias peças ou vídeos, anexe os arquivos {}
								compactados em um arquivo único em formato ZIP no campo para Upload.
							</p>
							<p className="text-black">
								Em caso de dúvidas, antes de finalizar o preenchimento, entre em contato {}
								com a nossa equipe através do e-mail gearbox@webmotors.com.br .
							</p>
						</Card>
						<Card
							title="Formulário de solicitação"
							subtitle="Se deseja contratar uma campanha especial, é só preencher o formulário abaixo, que entraremos em contato."
							classComponent="card-special-project"
						>
							<label>
								Insira o valor que você deseja investir:
							</label>
							<NumberFormat
								className="input-number"
								decimalScale={2}
								decimalSeparator=","
								prefix="R$ "
								thousandSeparator="."
								placeholder="R$ 0,00"
								format={Utils.currencyFormatter}
								onChange={e => setValue(e.target.value)}
								value={value}
							/>
							<label>
								Se possuir, faça o Upload das suas artes
							</label>
							<FileInput
								question=""
								required={false}
								clearField={!filesArray.length}
								nameField="filesArray"
								classField="col-12"
								classContainer="input-file"
								meta={{ attention: '' }}
								onGetValueField={setFilesArray}
								Hooks
							/>
							<label>
								Aproveite esse espaço para inserir as informações que achar relevante.
							</label>
							<textarea
								maxLength={500}
								onChange={e => setContent(e.target.value)}
								value={content}
							/>
							<span style={{ color: 'red ' }}>
								{ contentError && '*Este campo é obrigatório' }
							</span>
							<div className="textarea-count">
								<small>{ 500 - content.length }</small>
							</div>
							<Button
								type="button"
								padding="0px"
								fontSize="14px"
								onClick={() => sendForm()}
								height="40px"
								margin="10px 0px 4px 0px"
							>
								Enviar
							</Button>
						</Card>
					</>
				)
			}
		</Style.SpecialProjectContent>
	);
};

export default ProjetosEspeciais;
